import { CommunityItem, CommunityTabType } from '../../interfaces';

export interface FeedTabData {
  items: CommunityItem[];
  currentPage: number;
  isLoading: boolean;
  hasMore: boolean;
  scrollPosition: number;
  documentHeight?: number;
  lastViewedPostId?: string;
  targetPostId?: string;
}

export interface FeedState {
  tabs: FeedTabs;
  lastActiveTab?: CommunityTabType;
}

export type FeedTabs = { [K in CommunityTabType]?: FeedTabData };

export const initialFeedState: FeedState = {
  tabs: {},
};
